<template>
  <span class="tag-pill">
    {{ blok.text }}
  </span>
</template>

<script setup lang="ts">
import type { SbTagStoryblok } from '@/types'
interface Props {
  blok: SbTagStoryblok
}
defineProps<Props>()
</script>

<style lang="scss" scoped>
.tag-pill {
  @include paragraph-2xs;
  @include shadow-flat-soft;

  padding: 8px 16px;
  background-color: var(--white);
  border-radius: var(--border-radius-medium);
  width: fit-content;
  display: inline-block;

  @media (min-width: $breakpoint-lg) {
    @include paragraph-s;
  }
}
</style>
